import {
    Button,
    Form,
    NumberBox,
    SelectBox,
    TextBox,
} from 'devextreme-react';
import Validator, {
    PatternRule,
    RequiredRule,
    StringLengthRule
} from 'devextreme-react/validator';
import Toolbar from 'devextreme-react/toolbar';
// import { Label } from 'devextreme-react/cjs/form';
import { Item, Label } from 'devextreme-react/form';
import { LoadingPanel } from '../components/LoadingPanel';
import usePageTitle from '../hooks/usePageTitle';
/**
 * @todo Enable `material-blue-light` theme once all forms and datagrids have been 
 * refactored and mui has been depricated
 */
// import 'devextreme/dist/css/dx.material.blue.light.css';
import './FormConfig.scss';


const FormConfig = (
    {
        buttonConfiguration,
        formConfiguation,
        formFieldsConfiguration,
        headingTwo,
        isLoading,
        loadingMessage,
        title,
        validationGroupRef,
    }
) => {
    usePageTitle(title)

    return (
        // <div>foo</div>
        <div className='block__page-wrapper'>
            <div
                className='block__headingOne-wrapper'
                id='block__heading-wrapper'
            >
                <h1
                    className='form-h1'
                    id='global-h1'
                >
                    { title }
                </h1>
            </div>
            <div>
                <h2 className='block__headingTwo-wrapper'>
                    { headingTwo }
                </h2>
            </div>

            <Toolbar
                elementAttr={
                    {
                        class: 'form-config-toolbar',
                        id: 'form-config-toolbar'
                    }
                }
            >
                {
                    buttonConfiguration.map((key, index) => {
                        const {
                            disabled,
                            buttonType,
                            icon,
                            label,
                            onClick,
                            type,
                            variant,
                            visible
                        } = key;

                        const buttonHeight = 42.5;
                        const buttonWidth = 120;

                        switch (buttonType) {
                            case 'Back':
                                return (
                                    <Item
                                        key={index}
                                        location='after'
                                        visible={visible}
                                    >
                                        <div className='back-button-wrapper'>
                                            <Button
                                                elementAttr={
                                                    {
                                                        class: 'back-button',
                                                        id: 'back-button'
                                                    }
                                                }
                                                height={buttonHeight}
                                                icon={icon}
                                                onClick={onClick}
                                                text={label}
                                                type={type}
                                                stylingMode={variant}
                                                width={buttonWidth}
                                            />
                                        </div>
                                    </Item>
                                );
                            case 'Edit':
                                return (
                                    <Item
                                        key={index}
                                        location='after'
                                        visible={visible}
                                    >
                                        <div className='edit-button-wrapper'>
                                            <Button
                                                disabled={disabled}
                                                elementAttr={
                                                    {
                                                        class: 'edit-button',
                                                        id: 'edit-button'
                                                    }
                                                }
                                                height={buttonHeight}
                                                icon={icon}
                                                onClick={onClick}
                                                text={label}
                                                type={type}
                                                stylingMode={variant}
                                                width={buttonWidth}
                                            />
                                        </div>
                                    </Item>
                                );
                            case 'Save':
                                return (
                                    <Item
                                        key={index}
                                        location='after'
                                        visible={visible}
                                    >
                                        <div className='save-button-wrapper'>
                                            <Button
                                                disabled={disabled}
                                                elementAttr={
                                                    {
                                                        class: 'save-button',
                                                        id: 'save-button'
                                                    }
                                                }
                                                height={buttonHeight}
                                                icon={icon}
                                                onClick={onClick}
                                                text={label}
                                                type={type}
                                                stylingMode={variant}
                                                width={buttonWidth}
                                            />
                                        </div>
                                    </Item>
                                );
                            case 'Cancel':
                                return (
                                    <Item
                                        key={index}
                                        location='after'
                                        visible={visible}
                                    >
                                        <div className='cancel-button-wrapper'>
                                            <Button
                                                elementAttr={
                                                    {
                                                        class: 'cancel-button',
                                                        id: 'cancel-button'
                                                    }
                                                }
                                                height={buttonHeight}
                                                icon={icon}
                                                onClick={onClick}
                                                text={label}
                                                type={type}
                                                stylingMode={variant}
                                                width={buttonWidth}
                                            />
                                        </div>
                                    </Item>
                                );
                        }
                    })
                }
            </Toolbar>

            <Form
                colCount={formConfiguation.columnCount}
                ref={validationGroupRef}
                showValidationSummary={true}
                validationGroup='mainForm'
            >
                {
                    formFieldsConfiguration.map((key, index) => {
                        const {
                            colSpan,
                            elementAttr,
                            fieldType,
                            inputAttr,
                            label,
                            mask,
                            maskChar,
                            maskRules,
                            maxLength,
                            onValueChanged,
                            options,
                            pattern,
                            patternRequired,
                            patternMessage,
                            readOnly,
                            requiredRule,
                            requiredRuleMessage,
                            requiredRulePattern,
                            stringLengthMaximum,
                            stringLengthMessage,
                            stringLengthMinimum,
                            stringLengthRequired,
                            value,
                            visible
                        } = key;

                        switch (fieldType) {
                            case 'NumberBox':
                                return (
                                    <Item
                                        colSpan={colSpan}
                                        key={index}
                                        isRequired={requiredRule}
                                        visible={visible}
                                    >
                                        <Label
                                            location='top'
                                            showColon={false}
                                            text={label}
                                        >
                                        </Label>
                                        <NumberBox
                                            elementAttr={
                                                {
                                                    class: 'form-editor',
                                                    elementAttr,
                                                    id: `form-editor_${index}`
                                                }
                                            }
                                            inputAttr={
                                                {
                                                    'aria-label': label,
                                                    class: 'form-editor-input',
                                                    id: `form-editor-input_${index}`,
                                                    inputAttr,
                                                    'aria-required': requiredRule
                                                }
                                            }
                                            key={index}
                                            min={0}
                                            mode='text'
                                            onValueChanged={onValueChanged}
                                            readOnly={readOnly}
                                            showSpinButtons={false}
                                            step={0}
                                            stylingMode='filled'
                                            validationMessageMode='auto'
                                            value={value}
                                            visible={visible ?? true}
                                        >
                                            <Validator validationGroup='mainForm'>
                                                {
                                                    patternRequired &&
                                                    <PatternRule
                                                        message={patternMessage}
                                                        pattern={pattern}
                                                    />
                                                }
                                                {
                                                    requiredRule &&
                                                    <RequiredRule
                                                        message={requiredRuleMessage}
                                                        pattern={requiredRulePattern}
                                                    />
                                                }
                                                {
                                                    stringLengthRequired &&
                                                    <StringLengthRule
                                                        max={stringLengthMaximum}
                                                        message={stringLengthMessage}
                                                        min={stringLengthMinimum}
                                                    />
                                                }
                                            </Validator>
                                        </NumberBox>
                                    </Item>
                                );
                            case 'SelectBox':
                                return (
                                    <Item
                                        colSpan={colSpan}
                                        isRequired={requiredRule}

                                        key={index}
                                        visible={visible}
                                    >
                                        <Label
                                            location='top'
                                            showColon={false}
                                            text={label}
                                        >
                                        </Label>
                                        <SelectBox
                                            dataSource={options}
                                            elementAttr={
                                                {
                                                    class: 'form-editor',
                                                    elementAttr,
                                                    id: `form-editor_${index}`
                                                }
                                            }
                                            inputAttr={
                                                {
                                                    'aria-label': label,
                                                    class: 'form-editor-select',
                                                    id: `form-editor-select_${index}`,
                                                    'aria-required': requiredRule,
                                                    inputAttr
                                                }
                                            }
                                            key={index}
                                            onValueChanged={onValueChanged}
                                            readOnly={readOnly}
                                            searchEnabled={true}
                                            stylingMode='filled'
                                            validationMessageMode='auto'
                                            value={value}
                                            visible={visible ?? true}
                                        >
                                            <Validator validationGroup='mainForm'>
                                                {
                                                    requiredRule &&
                                                    <RequiredRule
                                                        message={requiredRuleMessage}
                                                        pattern={requiredRulePattern}
                                                    />
                                                }
                                            </Validator>
                                        </SelectBox>

                                    </Item>
                                );
                            case 'TextBox':
                                return (
                                    <Item
                                        colSpan={colSpan}
                                        isRequired={requiredRule}
                                        key={index}
                                        visible={visible}
                                    >
                                        <Label
                                            location='top'
                                            showColon={false}
                                            text={label}
                                        >
                                        </Label>
                                        <TextBox
                                            elementAttr={
                                                {
                                                    class: 'form-editor',
                                                    elementAttr,
                                                    id: `form-editor_${index}`
                                                }
                                            }
                                            inputAttr={
                                                {
                                                    'aria-label': label,
                                                    class: 'form-editor-input',
                                                    id: `form-editor-input_${index}`,
                                                    inputAttr,
                                                    'aria-required': requiredRule
                                                }
                                            }
                                            key={index}
                                            mask={mask}
                                            maskChar={maskChar}
                                            maskRules={maskRules}
                                            maxLength={maxLength}
                                            onValueChanged={onValueChanged}
                                            readOnly={readOnly}
                                            stylingMode='filled'
                                            isRequired={requiredRule}
                                            validationMessageMode='auto'
                                            value={value}
                                            visible={visible ?? true}
                                        >
                                            <Validator validationGroup='mainForm'>
                                                {
                                                    patternRequired &&
                                                    <PatternRule
                                                        message={patternMessage}
                                                        pattern={pattern}
                                                    />
                                                }
                                                {
                                                    requiredRule &&
                                                    <RequiredRule
                                                        message={requiredRuleMessage}
                                                        pattern={requiredRulePattern}
                                                    />
                                                }
                                                {
                                                    stringLengthRequired &&
                                                    <StringLengthRule
                                                        max={stringLengthMaximum}
                                                        message={stringLengthMessage}
                                                        min={stringLengthMinimum}
                                                    />
                                                }
                                            </Validator>
                                        </TextBox>
                                    </Item>
                                );
                        }
                    })
                }
            </Form>
            {
                isLoading &&
                <LoadingPanel location={{ of: '#contract-list' }} message={ loadingMessage } />
            }
        </div>
    );
};

export default FormConfig;